import React from "react";
import { PageHeader, Section } from "../components/ui-kit";
import { useContact } from "../context/SiteSettingsContext";

const Block = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-heading text-2xl font-semibold text-stone-900">{heading}</h2>
    <div className="space-y-3 text-lg text-stone-700 leading-relaxed">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  const CONTACT = useContact();
  return (
    <>
      <PageHeader
        eyebrow="Privacy"
        title="Privacy Policy"
        intro="This policy explains how Spire Inclusion handles the information you share with us through this website."
        testid="privacy-header"
      />
      <Section tone="white">
        <div className="max-w-3xl space-y-10">
          <Block heading="Who we are">
            <p>
              Spire Inclusion is a person-centred day service supporting young adults with
              disabilities. If you have any questions about this policy, contact us at {CONTACT.email}.
            </p>
          </Block>
          <Block heading="Information we collect">
            <p>
              When you use our enquiry form, we collect your name, your preferred contact method,
              your email address or phone number, your relationship to the person making the enquiry,
              the type of enquiry, and your message.
            </p>
            <p>
              Please do not include medical information, diagnoses, care plans or urgent safeguarding
              concerns in the enquiry form.
            </p>
          </Block>
          <Block heading="How we use your information">
            <p>
              We use the details you provide only to respond to your enquiry and to arrange any
              follow-up you have asked for. We do not sell your information.
            </p>
          </Block>
          <Block heading="How long we keep it">
            <p>
              We keep enquiry information only for as long as we need it to respond to you and to keep
              a reasonable record, after which it is securely removed.
            </p>
          </Block>
          <Block heading="Your rights">
            <p>
              You have the right to ask what information we hold about you, to ask us to correct it,
              and to ask us to delete it. To make a request, contact us using the details below.
            </p>
          </Block>
          <Block heading="Contact us">
            <p>Email: {CONTACT.email}</p>
            <p>Phone: {CONTACT.phone}</p>
            <p>Address: {CONTACT.address}</p>
          </Block>
        </div>
      </Section>
    </>
  );
}
